import { FileItemProps } from '@components/Core/Folders/FileItem/FileItem.component';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FileSystemNavigator from '@components/Core/Folders/FileSystemNavigator/FileSystemNavigator.component';

export type MoveFileDialogProps = {
  open: boolean;
  handleClose: () => void;
  files: FileItemProps[];
  handleSubmit: (paths: string[]) => void;
}

const MoveFileDialog = ({
  open,
  files,
  handleClose,
  handleSubmit
}: MoveFileDialogProps) => {
  const { t } = useTranslation();
  const [targetPath, setTargetPath] = useState<string>('');
  const [currentPath, setCurrentPath] = useState<string[]>([]);

  const onSubmitClicked = () => {
    handleSubmit(targetPath.split('/'));
  };

  const onCloseClicked = () => {
    setTargetPath('');
    handleClose();
  };

  const onPathSelected = (paths: string[]) => {
    setTargetPath(`${[t('templates.personal_templates'), ...paths].join('/')}`);
  };
  
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{ t('folders.move_file') } </DialogTitle>
      <DialogContent>
        <FileSystemNavigator
          currentPath={currentPath} 
          rootPathName={t('templates.personal_templates')} 
          files={files}
          onPathSelected={onPathSelected}
          filter={((file: FileItemProps) => file.type === 'folder')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseClicked} color="error">{ t('commons.cancel') }</Button>
        <Button onClick={onSubmitClicked} color="success">{ t('commons.move') }</Button>
      </DialogActions>
    </Dialog>
  )
}

export default MoveFileDialog;
